import { Box, Typography } from '@mui/material';
import SlotCounter from 'react-slot-counter';

import { DateRangeSelector } from '@/components';
import { cert } from '@/images';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectUserCompliance,
  useAppSelector,
  useFetchUserProfileQuery,
} from '@/store';
import { Certificate } from '@/types';

export const Header = ({
  selectedDateRange,
  setSelectedDateRange,
  credits,
}: {
  selectedDateRange: [Date, Date];
  setSelectedDateRange: (dateRange: [Date, Date]) => void;
  credits?: Certificate[];
}) => {
  const { data: profile } = useFetchUserProfileQuery();
  const compliance = useAppSelector(selectUserCompliance);
  const totalCredits =
    Math.round(
      (credits?.reduce((sum, credit) => sum + credit.credit, 0) || 0) * 100,
    ) / 100;
  if (!profile) {
    return null;
  }
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          gap: 4,
        },
        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: 122,
        },
      })}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Typography variant="h1" sx={{ mb: 4 }}>
          {profile.firstName}&apos;s Tracker
        </Typography>
        <Box
          sx={{
            maxWidth: {
              xs: '100%',
              sm: 380,
            },
          }}>
          <DateRangeSelector
            fromDate={selectedDateRange[0]}
            toDate={selectedDateRange[1]}
            onDateChange={setSelectedDateRange}
            referrer={{ page: EVENT_CONSTANTS.PAGE.TRACKER }}
          />
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: {
              xs: 'center',
              sm: 'flex-end',
            },
          }}>
          <Typography variant="h3" sx={{ color: 'secondary.main' }}>
            Total {compliance === 'CPD' ? 'CPD Hours' : 'CPE Credits'}
          </Typography>
          <Typography
            variant="caption1"
            sx={{
              color: 'text.light',
            }}>
            for {selectedDateRange[0].toLocaleDateString('en-US')} -{' '}
            {selectedDateRange[1].toLocaleDateString('en-US')}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: {
              xs: 'center',
              sm: 'flex-end',
            },
            mt: {
              xs: 1,
              sm: -0.5,
            },
          }}>
          <Box
            component="img"
            src={cert}
            sx={{ width: 55, height: 55, mr: 0.5, mt: 0.2 }}
          />
          <Typography variant="hero2">
            <SlotCounter startValue={0} value={totalCredits} />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
